/**
 * LISTING_FEE_ADMIN_PANEL.md §1.2 — tahsilat para birimi kullanıcının KYC
 * kimlik belgesinin ülkesinden türetilir: TR → TRY, Avrupa → EUR, ABD ve geri
 * kalan dünya → USD. Ne kullanıcı ne de panel bunu tek tek seçebilir; panelin
 * işi yalnızca bu para birimlerinde fiyat tanımlamaktır.
 *
 * Swagger bu alanları henüz taşımıyor (KycAdminItem / KycAdminItemData'da
 * yoklar), bu yüzden sözleşme burada elle tanımlanıp çağrı yerinde `as` ile
 * okunuyor. Şema güncellenince bu tipler silinebilir.
 */

/** İlan ücretinin tahsil edilebildiği para birimleri. */
export const BILLING_CURRENCIES = ["TRY", "EUR", "USD"];

/** Kyc/GetList satırına eklenen alanlar. */
export type KycBillingRow = {
  billingCurrency?: string | null;
  documentCountry?: string | null;
};

/** Kyc/GetById yanıtının kökündeki `billing` bloğu. */
export type KycBillingDetail = {
  billing?: { currencyCode?: string | null } | null;
};

/** Kyc/GetById yanıtındaki `kyc` kaydına eklenen alan. */
export type KycDocumentCountry = {
  documentCountry?: string | null;
};

/** ISO 3166-1 alpha-2 kodunu ülke adına çevirir; çözemezse kodu döndürür. */
export const countryLabel = (code?: string | null) => {
  const value = (code ?? "").trim().toUpperCase();
  if (!value) return null;

  try {
    const name = new Intl.DisplayNames(["tr"], { type: "region" }).of(value);
    return name && name !== value ? `${name} (${value})` : value;
  } catch {
    return value;
  }
};

/** Kullanıcının hangi para biriminde ödeyeceği; bilinmiyorsa `undefined`. */
export const billingCurrencyOf = (
  source?: KycBillingDetail | KycBillingRow | null
) => {
  const value =
    (source as KycBillingDetail | null)?.billing?.currencyCode ??
    (source as KycBillingRow | null)?.billingCurrency;

  return value ? value.toUpperCase() : undefined;
};
